import React from 'react';
import PropTypes from 'prop-types';
import TeeTimesWidgetGroup from './tee-times-widget-group';

const TeeTimesWidgetList = ({ groups, sitecorePlayers, ...props }) => {
    if (!Array.isArray(groups) || !sitecorePlayers) return null;

    return (
        <div aria-live="polite" className='tee-times-widget__scroll'>
            {
                groups.map((group, i) =>
                    <TeeTimesWidgetGroup
                        key={group.id}
                        sitecorePlayers={sitecorePlayers}
                        model={group}
                        isEven={i % 2 !== 0}
                        {...props}
                    />)
            }
        </div>
    );
};

TeeTimesWidgetList.propTypes = {
    groups: PropTypes.array,
};

export default TeeTimesWidgetList;
